/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-08-17 20:45:49
 */
// import common from './common';
import user from './user';
import personal from './personal';

const menus = [...user, ...personal];
export default menus;
